// https://github.com/cachecontrol/json-rules-engine/blob/HEAD/docs/rules.md#operators

export enum NUMERIC_OPERATORS {
  equal = 'equal',
  notEqual = 'notEqual',
  lessThan = 'lessThan',
  lessThanInclusive = 'lessThanInclusive',
  greaterThan = 'greaterThan',
  greaterThanInclusive = 'greaterThanInclusive',
}
